module.exports = require("node-polyglot");